const {
    IS_LOADING,
    TRANSACTION_LIST_SUCCESS,
    TRANSACTION_LIST_ERROR,
    TRANSACTION_DOWNLOAD_SUCCESS,
    TRANSACTION_GET_DOWNLOAD_FILES_ERROR,
    TRANSACTION_GET_DOWNLOAD_FILES_SUCCESS,
    TRANSACTION_DOWNLOAD_ERROR,
    TRANSACTION_FILTER_SUCCESS,
    TRANSACTION_FILTER_ERROR,
    WITHDRAWAL_LIST_SUCCESS, WITHDRAWAL_LIST_ERROR,
    WALLET_LIST_SUCCESS, WALLET_LIST_ERROR,
    WALLET_FILTER_SUCCESS, WALLET_FILTER_ERROR,
    WALLET_UPDATE_SUCCESS, WALLET_UPDATE_ERROR,
    TDS_LIST_SUCCESS, TDS_LIST_ERROR, WALLET_TRANS_SUCCESS, WALLET_TRANS_ERROR
} = require("../actions/Type");

const initialState = {
    loading: false,
    transaction_list: {},
    transaction_edit: {},
    withdrawal_list: {},
    wallet_list: {},
    wallet_update: {},
    tds_list: {},
    transaction_download_files: []
};

export const TransactionManagementReducers = (state = initialState, { type, payload } = {}) => {
    switch (type) {
        case IS_LOADING:
            return {
                ...state,
                loading: true,
            };
        case WALLET_LIST_SUCCESS:
            return {
                ...state,
                wallet_list: payload,
                loading: false,
                error: {}
            };
        case WALLET_LIST_ERROR:
            return {
                ...state,
                wallet_list: {},
                error: payload,
                loading: false,
            };
        case WALLET_UPDATE_SUCCESS:
            return {
                ...state,
                wallet_update: payload,
                loading: false,
            };
        case WALLET_UPDATE_ERROR:
            return {
                ...state,
                wallet_update: {},
                error: payload,
                loading: false,
            };
        case WALLET_FILTER_SUCCESS:
            return {
                ...state,
                wallet_list: payload,
                loading: false,
            };
        case WALLET_FILTER_ERROR:
            return {
                ...state,
                transaction_list: {},
                error: payload,
                loading: false,
            };

        case WITHDRAWAL_LIST_SUCCESS:
            return {
                ...state,
                withdrawal_list: payload,
                loading: false,
                error: {}
            };
        case WITHDRAWAL_LIST_ERROR:
            return {
                ...state,
                withdrawal_list: {},
                error: payload,
                loading: false,
            };

        case TRANSACTION_LIST_SUCCESS:
            return {
                ...state,
                transaction_list: payload,
                loading: false,
            };
        case TRANSACTION_LIST_ERROR:
            return {
                ...state,
                transaction_list: payload,
                loading: false,
            };
        case TRANSACTION_DOWNLOAD_SUCCESS:
            return {
                ...state,
                transaction_downoad: payload,
                loading: false,
            };
        case TRANSACTION_DOWNLOAD_ERROR:
            return {
                ...state,
                transaction_list: payload,
                loading: false,
            };
        case TRANSACTION_GET_DOWNLOAD_FILES_SUCCESS:
            return {
                ...state,
                transaction_download_files: payload || [],
                loading: false,
            };
        case TRANSACTION_GET_DOWNLOAD_FILES_ERROR:
            return {
                ...state,
                transaction_download_files: payload || [],
                loading: false,
            };
        case TRANSACTION_FILTER_SUCCESS:
            return {
                ...state,
                transaction_list: payload,
                loading: false,
            };
        case TRANSACTION_FILTER_ERROR:
            return {
                ...state,
                transaction_list: payload,
                loading: false,
            };
        case TDS_LIST_SUCCESS:
            return {
                ...state,
                tds_list: payload,
                loading: false,
            };
        case TDS_LIST_ERROR:
            return {
                ...state,
                tds_list: payload,
                loading: false,
            };
        case WALLET_TRANS_SUCCESS:
            return {
                ...state,
                trans_request: payload,
                loading: false,
            };
        case WALLET_TRANS_ERROR:
            return {
                ...state,
                trans_request: payload,
                loading: false,
            };
        default:
            return state;
    }
};
